import { MetaInfo } from '@/hooks/useSurvey';
import _ from 'lodash';

export const getDisabled = (metaInfo: MetaInfo[]) => _.filter(metaInfo, o => o.nTipo !== 2 && !o.bOpcional && (o.cValor == undefined || o.cValor === '' || o.cValor.length > 300)).length > 0
